import CorpPartnerList from './routes/partner_list/CorpPartnerList.vue';
import createCorpPartnerList from './routes/partner_list/component/createCorpPartnerList.vue';
import editCorpPartnerList from './routes/partner_list/component/editCorpPartnerList.vue';

import CorpSalesExcellence from './routes/corp_sales_excellence/CorpSalesExcellence.vue';
import createCorpSalesExcellence from './routes/corp_sales_excellence/component/createCorpSalesExcellence.vue';
import editCorpSalesExcellence from './routes/corp_sales_excellence/component/editCorpSalesExcellence.vue';

import CorpSalesTestimonial from './routes/corp_sales_testimonial/CorpSalesTestimonial.vue';
import createCorpSalesTestimonial from './routes/corp_sales_testimonial/component/createCorpSalesTestimonial.vue';
import editCorpSalesTestimonial from './routes/corp_sales_testimonial/component/editCorpSalesTestimonial.vue';

import bannerCorpSales from './routes/banner/Banner.vue';

const CorpSalesRoutes = [
    {
        path: '/banner-corp-sales',
        name: 'bannerCorpSales',
        component: bannerCorpSales,
    },
    {
        path: '/corp-sales-testimonial',
        name: 'CorpSalesTestimonial',
        component: CorpSalesTestimonial,
    },
    {
        path: '/create-corp-sales-testimonial',
        name: 'createCorpSalesTestimonial',
        component: createCorpSalesTestimonial,
    },
    {
        path: '/edit-corp-sales-testimonial/:id',
        name: 'editCorpSalesTestimonial',
        component: editCorpSalesTestimonial,
    },
    {
        path: '/corp-sales-excellence',
        name: 'CorpSalesExcellence',
        component: CorpSalesExcellence,
    },
    {
        path: '/create-corp-sales-excellence',
        name: 'createCorpSalesExcellence',
        component: createCorpSalesExcellence,
    },
    {
        path: '/edit-corp-sales-excellence/:id',
        name: 'editCorpSalesExcellence',
        component: editCorpSalesExcellence,
    },
    {
        path: '/corp-partner-list',
        name: 'CorpPartnerList',
        component: CorpPartnerList,
    },
    {
        path: '/create-corp-partner-list',
        name: 'createCorpPartnerList',
        component: createCorpPartnerList,
    },
    {
        path: '/edit-corp-partner-list/:id',
        name: 'editCorpPartnerList',
        component: editCorpPartnerList,
    },
];

export default CorpSalesRoutes;
